const c=({cdcTotalLimit:c,productBestPrice:l}={})=>null==c?"null":`cdc:${l}:parcelas:21x:limite:${c}`;export{c as buildDimension10};
